
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debit-note",
      function () {
        return require("private-next-pages/debit-note.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/debit-note"])
      });
    }
  